import { ISuccessPredictorState, statePropName } from './slice';
import { calculateAvgGameplaysForLevelUp, findWorkoutPrediction } from './utils';

export interface IAppState {
  // this feature state
  [statePropName]: ISuccessPredictorState;
  // other features we don't care of
  [otherKeys: string]: any;
}

const getFeatureState = (state: IAppState) => state[statePropName];

export const isLoading = (state: IAppState) => getFeatureState(state).loading;

const getPredictions = (state: IAppState) => getFeatureState(state).predictions;

export const getWorkoutPrediction = (state: IAppState, workoutId: number) =>
  findWorkoutPrediction(getPredictions(state), workoutId);

export const workoutPredictionIsLoading = (state: IAppState, workoutId: number) =>
  !getWorkoutPrediction(state, workoutId);

export const getCalculatedAvgGameplaysForLevelUp = (state: IAppState, workoutId: number, difficulty: number) => {
  const prediction = getWorkoutPrediction(state, workoutId);
  return calculateAvgGameplaysForLevelUp(difficulty, prediction);
};
